module.exports = __webpack_public_path__ + "static/media/free.af56b796.svg";